import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SelectivePreloadingStrategyService implements PreloadingStrategy {
    public preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
        if (route.data?.preload === true) {
            return load();
        }

        return of(null);
    }
}
